import { Injectable } from "@angular/core";
import { BaseService } from "../api-service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { apiPath } from "../const";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LookUpService extends BaseService {
  constructor(public httpClient: HttpClient, public Alerts: MatSnackBar,
  ) {
    super(httpClient);
  }


  getAllSkillsForLookup() {
    let onSuccess = (value) => {
      let data = value.value;
      if (data.meta.success) {
        return data.data;
      }
      else {
        this.Alerts.open(data.meta.message, 'ok');
      }
    }
    return this.service(this.get(apiPath)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  getAllCountries() {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error','ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getCountries)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  getAllStates(value) {
    let param=new HttpParams().set('code',value)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error','ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getStates,param)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  getAllCities(value) {
    let param=new HttpParams().set('code',value)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error','ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getCities,param)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
}
